module.exports = __webpack_public_path__ + "img/1557614064775012354.1581f8ff.png";